import { useQuery } from '@apollo/client';
import { GET_USER_MEMBERSHIP_DETAILS } from '../graphql';

const useMembershipDetails = () => {
  const {
    data: membershipData,
    loading: membershipLoading,
    error: membershipError,
  } = useQuery(GET_USER_MEMBERSHIP_DETAILS, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    error: membershipError,
    loading: membershipLoading,
    userHasPastVoloFitnessMembership: membershipData?.userHasPastVoloFitnessMembership || false,
    userIsActiveVoloFitnessMember: membershipData?.userIsActiveVoloFitnessMember || false,
    activeVoloFitnessMembership: membershipData?.activeVoloFitnessMembership || {},
    userHasPastVoloPassMembership: membershipData?.userHasPastVoloPassMembership || false,
    userIsActiveVoloPassMember: membershipData?.userIsActiveVoloPassMember || false,
    activeVoloPassMembership: membershipData?.activeVoloPassMembership || {},
  };
};

export default useMembershipDetails;
